module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/zoom-icon.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/zoom-icon.ttf
// module id = 386
// module chunks = 0